import { GetAccountResponse } from "@/api/model"
import { buildFullAddressLine } from "@/lib/shared/addressHelper"
import { computed, ComputedRef, Ref } from "vue"

export default (
  accountData: Ref<GetAccountResponse | undefined>,
): ComputedRef<string> =>
  computed(() => {
    if (!accountData.value?.supplyAddress) return "-"
    return buildFullAddressLine(accountData.value.supplyAddress)
  })
